import Adjust from './adjusts/adjust';
var ADJUST_MAP = {};
/**
 * æ ¹æ®ç±»åè·å Adjust ç±»
 * @param type
 */
var getAdjust = function (type) {
    return ADJUST_MAP[type.toLowerCase()];
};
/**
 * æ³¨åèªå®ä¹ Adjust
 * @param type
 * @param ctor
 */
var registerAdjust = function (type, ctor) {
    // æ³¨åçæ¶åï¼éè¦æ ¡éª type éåï¼ä¸åºåå¤§å°å
    if (getAdjust(type)) {
        throw new Error("Adjust type '" + type + "' existed.");
    }
    // å­å¨å° map ä¸­
    ADJUST_MAP[type.toLowerCase()] = ctor;
};
export { getAdjust, registerAdjust, Adjust };
export * from './interface';
//# sourceMappingURL=factory.js.map